/**
 * @author Ahmed Samer
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2019-09-24
 * @description Implementation of  companies and organizations inner page.
 * @filename invitation-lading.tsx
 */

import React from "react";
import { AccountVerificationModal } from "../../modals/register-and-login/account-verification-modal";
import $ from "jquery";
import { AccountControl } from "../../modals/register-and-login/account-control";
import { ERROR_MESSAGES } from "../../../constants/errors-constants";
import { RdvButton } from "../../page-framework/rdv-button";

/**
 *
 *
 * @interface RegistrationInput
 */
interface RegistrationInput {
  /**
   *
   *
   * @type {string}
   * @memberof RegistrationInput
   */
  userName: string;

  /**
   *
   *
   * @type {string}
   * @memberof RegistrationInput
   */
  email: string;

  /**
   *
   *
   * @type {string}
   * @memberof RegistrationInput
   */
  password: string;
}

/**
 *
 *
 * @export
 * @interface InvitationLandingPanelProps
 */
export interface RegistersFormProps {
  /**
   *
   *
   * @type {string}
   * @memberof InvitationLandingPanelProps
   */
  handleRegisterSuccess: Function;

  /**
   *
   *
   * @type {string}
   * @memberof InvitationLandingPanelProps
   */
  handleRegisterFailure: Function;

  /**
   *
   *
   * @type {Function}
   * @memberof RegistersFormProps
   */
  triggerLoader: Function;
}

/**
 *
 *
 * @export
 * @interface RegistersFormState
 */
export interface RegistersFormState {
  /**
   *
   *
   * @type {RegistrationInput}
   * @memberof InvitationLandingPanelState
   */
  registration: RegistrationInput;

  /**
   *
   *
   * @type {boolean}
   * @memberof InvitationLandingPanelState
   */
  loading: boolean;
}

export class RegistersForm extends React.Component<
  RegistersFormProps,
  RegistersFormState
> {
  constructor(props: RegistersFormProps) {
    super(props);

    // ... bind needed function to class
    this.handleEmailChanges = this.handleEmailChanges.bind(this);
    this.handleNameChanges = this.handleNameChanges.bind(this);
    this.handlePasswordChanges = this.handlePasswordChanges.bind(this);
    this.handleSignUpAction = this.handleSignUpAction.bind(this);

    this.state = {
      loading: false,
      registration: { email: "", password: "", userName: "" },
    };
  }

  /**
   *
   *
   * @param {*} event
   * @memberof InvitationLandingPanel
   */
  handleSignUpAction(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    event.preventDefault();

    this.props.triggerLoader(true);

    let promise: Promise<any> = Promise.resolve();
    promise = promise.then(() => {
      return import("../../../authentication/cognito-client").then((module) => {
        return module.CognitoClient.createAccountUsingEmailAndPassword(
          this.state.registration.email,
          this.state.registration.password,
          this.state.registration.userName
        );
      });
    });

    promise = promise.then((value) => {
      if (value === null || value === undefined) {
        throw new Error("invalid sign up response data");
      }

      $(`#Invitation_Modal`).modal({
        keyboard: false,
        backdrop: "static",
        show: true,
      });
    });

    promise = promise.catch((err) => {
      console.error(err);

      if (this.props.handleRegisterFailure) {
        this.props.handleRegisterFailure(err.message);
      }
    });

    promise = promise.finally(() => {
      this.props.triggerLoader(false);
    });
  }

  /**
   *
   *
   * @param {React.FormEvent<HTMLInputElement>} changeEvent
   * @memberof PersonPage
   */
  handlePasswordChanges(
    changeEvent: React.FormEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void {
    // ... define need variables
    const registration: RegistrationInput = this.state.registration;
    const eventValue: string = changeEvent.currentTarget.value;

    // ... prevent handle default action if it a button or any submit action
    changeEvent.preventDefault();
    // ... validate against input errors
    // ... assign value if valid
    registration.password = eventValue;
    this.setState({ registration });
  }

  /**
   *
   *
   * @param {React.FormEvent<HTMLInputElement>} changeEvent
   * @memberof PersonPage
   */
  handleEmailChanges(
    changeEvent: React.FormEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void {
    // ... define need variables
    const registration: RegistrationInput = this.state.registration;
    const eventValue: string = changeEvent.currentTarget.value;
    // // console\.log("[handleResponsibilityChanges] provided value : ", eventValue);
    // ... prevent handle default action if it a button or any submit action
    changeEvent.preventDefault();
    // ... validate against input errors
    // ... assign value if valid
    registration.email = eventValue;
    this.setState({ registration });
  }

  /**
   *
   *
   * @param {React.FormEvent<HTMLInputElement>} changeEvent
   * @memberof PersonPage
   */
  handleNameChanges(
    changeEvent: React.FormEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void {
    // ... define need variables
    const registration: RegistrationInput = this.state.registration;
    const eventValue: string = changeEvent.currentTarget.value;
    // // console\.log("[handleResponsibilityChanges] provided value : ", eventValue);
    // ... prevent handle default action if it a button or any submit action
    changeEvent.preventDefault();
    // ... validate against input errors
    // ... assign value if valid
    registration.userName = eventValue;
    this.setState({ registration });
  }

  render() {
    return (
      <div className="invitation-section add-media-modal">
        <form noValidate={true}>
          <div className="form-group row">
            <div className="col-sm-6 col-xs-12">
              <label htmlFor={"firstName"}>
                <span>
                  First Name <span className="required">*</span>
                </span>
              </label>
              <input
                type="text"
                name="firstName"
                autoComplete="firstname"
                className="form-control"
                id="firstName"
                value={this.state.registration.userName}
                onChange={this.handleNameChanges}
                autoFocus={true}
                placeholder="Please enter your first name"
                required={true}
              />
            </div>
            <div className="col-sm-6 col-xs-12">
              <label htmlFor={"lastName"}>
                <span>Last Name</span>
              </label>
              <input
                type="text"
                name="lastName"
                autoComplete="off"
                className="form-control"
                id="lastName"
                placeholder="Please enter your last name"
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-sm-12 col-xs-12">
              <label htmlFor={"email"}>
                <span>
                  Email Address <span className="required">*</span>
                </span>
              </label>
              <input
                type="email"
                name="email"
                autoComplete="off"
                className="form-control"
                id="email"
                value={this.state.registration.email}
                onChange={this.handleEmailChanges}
                placeholder="Email Address"
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-sm-12 col-xs-12">
              <label htmlFor={"password"}>
                <span>
                  Password <span className="required">*</span>
                </span>
              </label>
              <input
                type="password"
                name="password"
                autoComplete="off"
                className="form-control mb-4"
                id="password"
                value={this.state.registration.password}
                onChange={this.handlePasswordChanges}
                placeholder="Password"
              />
              <p className="password-instructions">
                <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgMGMtNi42MjcgMC0xMiA1LjM3My0xMiAxMnM1LjM3MyAxMiAxMiAxMiAxMi01LjM3MyAxMi0xMi01LjM3My0xMi0xMi0xMnptMSAxOGgtMnYtNmgtMnYtMmg0djh6bS0xLTkuNzVjLS42OSAwLTEuMjUtLjU2LTEuMjUtMS4yNXMuNTYtMS4yNSAxLjI1LTEuMjUgMS4yNS41NiAxLjI1IDEuMjUtLjU2IDEuMjUtMS4yNSAxLjI1eiIvPjwvc3ZnPg==" />
                <span>
                  {`  Password must be at least 8 characters long. The password must contain these four character categories among the following: Uppercase characters (A-Z) Lowercase characters (a-z) Number (0-9) & Special characters (^$*.[]{}()?-"!@#%&/\,><':;|_~\`)  `}
                </span>
              </p>
            </div>
          </div>
          <div className="form-group row">
            <div className="form-group checkSection col-md-12">
              <input
                type="checkbox"
                id="allowExtraEmails"
                name="allowExtraEmails"
                value=""
              />
              <label htmlFor="allowExtraEmails">
                I want to receive inspiration, marketing promotions and updates
                via email.
              </label>
            </div>
          </div>
          <RdvButton
            type="submit"
            extraClassName="btn-root"
            onClick={this.handleSignUpAction}
            text="Proceed"
          />
        </form>
        <AccountControl
          activeModal={AccountVerificationModal}
          modalId={"Invitation_Modal"}
          modalProps={{
            email: this.state.registration.email,
            onSuccess: () => {
              this.props.handleRegisterSuccess(
                this.state.registration.email,
                this.state.registration.password
              );
            },
            onFailure: this.props.handleRegisterFailure,
          }}
        />
      </div>
    );
  }
}
